import { render, staticRenderFns } from "./MenuSuspenso.vue?vue&type=template&id=03d8ecfa&scoped=true"
import script from "./MenuSuspenso.vue?vue&type=script&lang=js"
export * from "./MenuSuspenso.vue?vue&type=script&lang=js"
import style0 from "./MenuSuspenso.vue?vue&type=style&index=0&id=03d8ecfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d8ecfa",
  null
  
)

export default component.exports